// extracted by mini-css-extract-plugin
export default {"chat":"styles_chat__1for5","menu-btn":"styles_menu-btn__gXFJj"};